import RequestHandler from "./request-handler";
class TaskCommentService {
    constructor() {
        this.path = "taskcomments";
        if (TaskCommentService.instance) {
            return TaskCommentService.instance;
        }
        TaskCommentService.instance = this;
        return this;
    }
    async get(loadOptions) {
        return await RequestHandler.getWithParams(this.path, loadOptions);
    }
    async getByTaskId(id) {
        return await RequestHandler.get(`${this.path}/getByTaskId`, id);
    }
    async attachment(id) {
        return await RequestHandler.getWithParams(`${this.path}/attachment/${id}`, {}, 'blob');
    }
    async screenshot(id) {
        return await RequestHandler.get(`${this.path}/screenshot`, id);
    }
    async insert(data) {
        return await RequestHandler.post(this.path, data);
    }
    async update(data) {
        return RequestHandler.put(this.path, data);
    }
    async delete(id) {
        return await RequestHandler.delete(this.path, id);
    }
}
const instance = new TaskCommentService();
export default instance;